import { render, staticRenderFns } from "./OrderAddressForm.vue?vue&type=template&id=17cb9fbc&"
import script from "./OrderAddressForm.vue?vue&type=script&lang=js&"
export * from "./OrderAddressForm.vue?vue&type=script&lang=js&"
import style0 from "./OrderAddressForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports